import React from "react";
import { useCustomer } from "hooks/useStore";

const ClaimedRewardsList = ({ data }) => {
	const { isAuthenticated } = useCustomer(["isAuthenticated"]);
	if (!isAuthenticated) return null;

	return (
		<div id="rewards">
			{data?.title && <h2 className="text-center pb-10">{data.title}</h2>}
			<div data-lion-claimed-rewards-list></div>
		</div>
	);
};

export default ClaimedRewardsList;